import React, {Component, Fragment} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane
} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData, postData} from '../../../api/doLogin.js';
import "video-react/dist/video-react.css";
import classnames from 'classnames';
import {formsUpdater, getFormFieldValue} from "../../Applications/shared/shared";
import {PermissionDisplayList} from "../../../api/permissionHelper";
import Select from "react-select";
import '../../../../scss/vendors/react-select/react-select.scss';
import {EventClient} from "../../../util/eventClient";
import {UserLMSSelection} from "./UserLMSSelection";
import {UserBriefcaseSelection} from "./UserBriefcaseSelection";
import {UserAgencySelection} from "./UserAgencySelection";
import {UserPolicyLink} from "./UserPolicyLink";
import {UserCalendarsSelection} from "./UserCalendarsSelection";
import {UserManagerSelection} from "./UserManagerSelection";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export class UserAddEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      agencies: [],
      formData: {locked: 0},
      policies: [],
      managingUsers: [],
      active: true,
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {},
      activeTab: "general",
      subSelection: ""
    };
    this.defaultNewUser = {locked: 0, admin: 0, userIncentiveLevel: 0};

  }

  toggleTab(tab) {
    this.setState({activeTab: tab});
  }

  componentDidMount() {
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
    this.updateData();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.match.params.type !== this.props.match.params.type) {
  //     this.updateData();
  //   }
  // }

  saveUser() {
    if (!this.state.formData.FName) {
      return EventClient.emit("TOAST_ERROR", "Please enter First Name.");
    }
    if (!this.state.formData.LName) {
      return EventClient.emit("TOAST_ERROR", "Please enter Last Name.");
    }
    if (!this.state.formData.agency) {
      return EventClient.emit("TOAST_ERROR", "Please select an agency.");
    }
    if (this.state.formData.tz === "" || this.state.formData.tz === undefined || this.state.formData.tz === null) {
      return EventClient.emit("TOAST_ERROR", "Please select a time zone.");
    }
    if (!this.state.formData.username) {
      return EventClient.emit("TOAST_ERROR", "Please enter username.");
    }
    if (this.state.formData.password && this.state.formData.password !== this.state.formData.password2) {
      return EventClient.emit("TOAST_ERROR", "Passwords do not match.");
    }
    if (this.state.formData.AFBNPass && this.state.formData.AFBNPass !== this.state.formData.AFBNPass2) {
      return EventClient.emit("TOAST_ERROR", "AFBN Email Passwords do not match.");
    }
    const {password2, AFBNPass2, ...formData} = this.state.formData;
    var self = this;
    formData['managingUsers'] = this.state.managingUsers.filter((user) => {
      return user.mngd === 1;
    }).map((user) => ({id: user.id, premPercent: user.premPercent}));
    postData(`admin/users/${this.props.match.params.user_id}`, formData)
      .then((data) => {
        if (data.status === "Success") {
          EventClient.emit("TOAST_SUCCESS", "User Saved.");
          self.props.history.push(`/admin/users`);
        } else {
          EventClient.emit("TOAST_ERROR", data.message);
        }
      })
      .catch(error => {
        EventClient.emit("TOAST_ERROR", error.message);
        console.error(error);
      });
  }

  updateData() {
    // if (this.props.match.params.user_id === "new") {
    //   return this.setState({dataLoaded: true, user: {}, activeTab: "general"});
    // }
    var self = this;
    getData(`admin/users/${this.props.match.params.user_id}/${this.props.match.params.user_id === "new" ? "new" : this.state.activeTab}`, {})
      .then((data) => {
        if (data.status === "Success") {
          self.setState({
            formData: data.data.user || {...self.defaultNewUser},
            agencies: data.data.agencies,
            policies: data.data.policies || [],
            managingUsers: data.data.managingUsers || [],
            dataLoaded: true
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  onPolicyAdd(table, id) {
    this.setState({
      policies: this.state.policies.map((pol) => {
        if (pol.table === table && String(pol.id) === id) {
          return {...pol, enabled: 1}
        } else {
          return pol
        }
      })
    })
  }

  onPolicyRemove(table, id) {
    this.setState({
      policies: this.state.policies.map((pol) => {
        if (pol.table === table && pol.id === id) {
          return {...pol, enabled: 0}
        } else {
          return pol
        }
      })
    })
  }

  manageSubSelection(type) {
    if (this.state.formData.id) {
      this.setState({subSelection: type});
    } else {
      EventClient.emit("TOAST_ERROR", "Must Create User first.");
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded ? (
          <Card>
            <CardHeader>
              <i
                className="icon-menu"></i>{(this.state.formData.FName || this.state.formData.LName) ? `Editing ${this.state.formData.FName} ${this.state.formData.LName}` : "Adding New User"}
              <div className="card-actions">
                <button onClick={() => {
                  this.saveUser();
                }}>
                  <small className="text-muted">Save</small>
                </button>
                <button onClick={() => {
                  this.props.history.push("/admin/users");
                }}>
                  <small className="text-muted">Cancel</small>
                </button>
                {/*<button onClick={() => this.updateData()}>*/}
                {/*  <small className="text-muted">Refresh</small>*/}
                {/*</button>*/}
              </div>

            </CardHeader>
            <CardBody>
              <Nav tabs style={{cursor: "pointer"}}>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === 'general'})}
                    onClick={() => this.toggleTab('general')}>
                    General
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === 'advanced'})}
                    onClick={() => this.toggleTab('advanced')}>
                    Advanced
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === 'Manager'})}
                    onClick={() => this.toggleTab('manager')}>
                    Manager
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === 'permissions'})}
                    onClick={() => this.toggleTab('permissions')}>
                    Permissions
                  </NavLink>
                </NavItem>

                {this.props.match.params.user_id !== "new" && (
                  <Fragment>
                    <NavItem>
                      <NavLink
                        className={classnames({active: this.state.activeTab === 'policy'})}
                        onClick={() => this.toggleTab('policy')}>
                        Agent IDs
                      </NavLink>
                    </NavItem>
                  </Fragment>
                )}

              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="general">
                  <Row>
                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="FName">First Name</Label>
                        <Input
                          type="text"
                          id="FName"
                          value={getFormFieldValue(this.state.formData['FName'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="LName">Last Name</Label>
                        <Input
                          type="text"
                          id="LName"
                          value={getFormFieldValue(this.state.formData['LName'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="address1">Address 1</Label>
                        <Input
                          type="text"
                          id="address1"
                          value={getFormFieldValue(this.state.formData['address1'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="address2">Address 2</Label>
                        <Input
                          type="text"
                          id="address2"
                          value={getFormFieldValue(this.state.formData['address2'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="city">City</Label>
                        <Input
                          type="text"
                          id="city"
                          value={getFormFieldValue(this.state.formData['city'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="state">State</Label>
                        <Input
                          type="text"
                          id="state"
                          value={getFormFieldValue(this.state.formData['state'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="zip">Zip</Label>
                        <Input
                          type="text"
                          id="zip"
                          value={getFormFieldValue(this.state.formData['zip'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"} style={{marginTop: 40}}>
                        <Label for="phone">Phone (internal)</Label>
                        <Input
                          type="text"
                          id="phone"
                          value={getFormFieldValue(this.state.formData['phone'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="email">Email</Label>
                        <Input
                          type="text"
                          id="email"
                          value={getFormFieldValue(this.state.formData['email'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="agency">Agency</Label>
                        <Input
                          type="select"
                          id="agency"
                          value={getFormFieldValue(this.state.formData['agency'] || 0)}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                          <option key={0} value={0} disabled>Choose ...</option>
                          {this.state.agencies && this.state.agencies.map((agency) => {
                            return (<option key={String(agency.id)} value={agency.id}>{agency.display}</option>)
                          })}
                        </Input>
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="tz">Time Zone</Label>
                        <Input
                          type="select"
                          id="tz"
                          value={getFormFieldValue(this.state.formData['tz'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                          <option key={"a"} value={''} disabled>Choose ...</option>
                          <option key={0} value={3}>Eastern</option>
                          <option key={1} value={2}>Central</option>
                          <option key={2} value={1}>Mountain</option>
                          <option key={3} value={0}>Pacific</option>
                        </Input>
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="title">Title</Label>
                        <Input
                          type="text"
                          id="title"
                          value={getFormFieldValue(this.state.formData['title'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="sigphone">Phone (Signature Block)</Label>
                        <Input
                          type="text"
                          id="sigphone"
                          value={getFormFieldValue(this.state.formData['sigphone'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"} style={{marginTop: 40}}>
                        <Label for="username">Username</Label>
                        <Input
                          type="text"
                          id="username"
                          autoComplete="new-username"
                          value={getFormFieldValue(this.state.formData['username'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="password">Password</Label>
                        <Input
                          type="password"
                          id="password"
                          autoComplete="new-password"
                          value={getFormFieldValue(this.state.formData['password'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="password2">Password (confirm)</Label>
                        <Input
                          type="password"
                          id="password2"
                          autoComplete="new-password"
                          value={getFormFieldValue(this.state.formData['password2'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"} style={{marginTop: 40}}>
                        <Label for="locked">Account Status</Label>
                        <Input
                          type="select"
                          id="locked"
                          value={getFormFieldValue(this.state.formData['locked'] || 0)}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                          <option key={0} value={0}>Active</option>
                          <option key={1} value={1}>Locked</option>
                        </Input>
                      </FormGroup>
                    </Col>

                  </Row>
                </TabPane>

                <TabPane tabId="advanced">
                  <Row>
                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="admin">Account Type</Label>
                        <Input
                          type="select"
                          id="admin"
                          value={getFormFieldValue(this.state.formData['admin'] || 0)}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                          <option key={0} value={0}>Normal</option>
                          <option key={1} value={1}>Administrator</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="userIncentiveLevel">Incentive Level</Label>
                        <Input
                          type="select"
                          id="userIncentiveLevel"
                          value={getFormFieldValue(this.state.formData['userIncentiveLevel'] || 0)}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                          <option key={0} value={0}>None</option>
                          <option key={1} value={1}>Agent</option>
                          <option key={2} value={2}>Manager</option>
                          <option key={3} value={3}>General Agent</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="fullSignature">Career Signature Block</Label>
                        <Input
                          type="textarea"
                          rows={5}
                          id="fullSignature"
                          value={getFormFieldValue(this.state.formData['fullSignature'] || "")}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"} style={{marginTop: 40}}>
                        <Label for="AFBNEmail">AFBN Email</Label>
                        <Input
                          type="text"
                          id="AFBNEmail"
                          autoComplete="new-username"
                          value={getFormFieldValue(this.state.formData['AFBNEmail'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="AFBNPass">AFBN Email Password</Label>
                        <Input
                          type="password"
                          id="AFBNPass"
                          autoComplete="new-password"
                          value={getFormFieldValue(this.state.formData['AFBNPass'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="AFBNPass2">Password (confirm)</Label>
                        <Input
                          type="password"
                          id="AFBNPass2"
                          autoComplete="new-password"
                          value={getFormFieldValue(this.state.formData['AFBNPass2'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tabId="permissions">
                  <div>*Changes take effect on save and after next login</div>
                  <Table>
                    <thead>
                    <tr>
                      <th>Permission</th>
                      <th>Allowed</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Object.keys(PermissionDisplayList).map((key) => {
                      return (
                        <tr key={key}>
                          <td><span>{PermissionDisplayList[key].display}</span>{PermissionDisplayList[key].button && (
                            <span>&nbsp;&nbsp;<Button
                              onClick={() => this.manageSubSelection(key)}>{PermissionDisplayList[key].button}</Button></span>)}
                          </td>
                          <td>
                            <Select
                              id={key}
                              name={`perm-${key}}`}
                              value={this.state.formData.perms && this.state.formData.perms[key] || []}
                              options={PermissionDisplayList[key].values}
                              onChange={(selectedValues) => this.setState({
                                formData: {
                                  ...this.state.formData,
                                  perms: {
                                    ...this.state.formData.perms,
                                    [key]: selectedValues.map((val) => val.value).sort()
                                  }
                                }
                              })}
                              multi
                            />
                          </td>
                        </tr>
                      )
                    })}
                    </tbody>
                  </Table>
                </TabPane>
                <TabPane tabId={"policy"}>
                  <UserPolicyLink user={this.state.formData} policies={this.state.policies || []}
                                  onAdd={(table, id) => this.onPolicyAdd(table, id)}
                                  onRemove={(table, id) => this.onPolicyRemove(table, id)}/>
                </TabPane>
                <TabPane tabId={"manager"}>
                  <Row>
                    <Col sm={6} xs={12}>
                      <FormGroup className={"form-group-condensed"}>
                        <Label for="mgrIncentiveLevel">Manager Incentive Level</Label>
                        <Input
                          type="select"
                          id="mgrIncentiveLevel"
                          value={getFormFieldValue(this.state.formData['mgrIncentiveLevel'] || 0)}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                        >
                          <option key={0} value={0}>None</option>
                          <option key={2} value={2}>Manager</option>
                          <option key={3} value={3}>General Agent</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} xs={12}>
                      <Label>Assign Agents who's total premiums paid are accounted for</Label>
                      <UserManagerSelection users={this.state.managingUsers}
                                            onUpdate={(managingUsers) => this.setState({managingUsers})}/>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        ) : (
          <div className="app flex-row align-items-center">
            <Container>
              <Row className="justify-content-center">
                <Col md="6">
                  <div className="clearfix">

                    <h4 className="pt-4" style={{textAlign: 'center'}}>Please wait while we load this user...</h4>
                  </div>
                  <Card>
                    <CardBody>
                      <div className="sk-wave">
                        <div className="sk-rect sk-rect1"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect2"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect3"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect4"></div>
                        &nbsp;
                        <div className="sk-rect sk-rect5"></div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        )
        } {
        this.state.formData.id && this.state.subSelection === "calendar" && (
          <UserCalendarsSelection user={this.state.formData}
                                  onClose={() =>
                                    this.setState({subSelection: ""})

                                  }/>
        )
      }

        {
          this.state.formData.id && this.state.subSelection === "lms" && (
            <UserLMSSelection user={this.state.formData} onClose={() => this.setState({subSelection: ""})}/>
          )
        }
        {
          this.state.formData.id && this.state.subSelection === "briefcase" && (
            <UserBriefcaseSelection user={this.state.formData} onClose={() => this.setState({subSelection: ""})}/>
          )
        }
        {
          this.state.formData.id && this.state.subSelection === "taxes" && (
            <UserAgencySelection user={this.state.formData} onClose={() => this.setState({subSelection: ""})}/>
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Admin/Users/UserAddEdit.js